module.exports = __webpack_public_path__ + "static/media/02-banner-reabrimos-background@2x.e8b2f669.jpg";